module.exports = __webpack_public_path__ + "palau.svg?c0776ae9ad7cccb7c7a2c5430eaf0abb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/palau.svg
// module id = 260
// module chunks = 10